// extracted by mini-css-extract-plugin
export default {"page":"CQ-z","cartModal":"DQ-z","checkout":"EQ-z","placeholder":"FQ-z","account":"GQ-z"};